import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {OldRoutes, RoutingEnum} from '../../enums/routing.enum';

export const hashPagesGuard: CanActivateFn = (route, state) => {
  if (typeof window === 'undefined') {
    return true;
  }
  const router = inject(Router);
  // console.count('redirect');
  // console.log('isPlatformBrowser(PLATFORM_ID)', isPlatformBrowser(PLATFORM_ID), state,);
  const hashPosition = state.url.indexOf('#');

  if (hashPosition >= 1) {
    const realUrl = new URL(route.fragment ?? '', window.location.origin);
    const path = realUrl.pathname.slice(1);
    const params = new URLSearchParams(realUrl.search);
    const cParam = params.get('c');

    if (path === '' && cParam === 'lithium') {
      return router.createUrlTree([RoutingEnum.Energia]);
    }
    const correctedOldRoutes = Object.keys(OldRoutes).find((el) => path.indexOf(el) >= 0);
    return router.createUrlTree([correctedOldRoutes ? OldRoutes[correctedOldRoutes] : path], {
      queryParams: Object.fromEntries(params),
    });
  }
  // console.log('quuiiii');
  return true;
};
